projectFunctions.printDatasheetFunctions = projectFunctions.printDatasheetFunctions || {};

/**
 * Init: Will be triggered on document ready.
 */
projectFunctions.printDatasheetFunctions.init = function() {
    this.printDatasheet();
};

projectFunctions.printDatasheetFunctions.printDatasheet = function () {
    $(document).on('click', '#download-datasheet', function (e) {
        e.preventDefault();
    
        let productId = $(this).data('product-id'),
          variationtId = $(this).data('variation-id');
    
        // Fetch datasheet content
        $.ajax({
          type: 'POST',
          url: AjaxMethodsUrl,
          data: {
            action: 'print_datasheet',
            product_id: productId,
            variation_id: variationtId,
            nonce: printDatasheet.nonce,
            lang: wpml_data.lang
          },
          success: function (response) {
            if (response.success) {
              var pdfBase64 = response.data.pdf; // Get the base64 PDF data
              var fileName = response.data.fileName;
    
              // Convert base64 string to binary data
              var byteCharacters = atob(pdfBase64); // Decode base64 string to byte characters
              var byteArrays = [];
              for (var offset = 0; offset < byteCharacters.length; offset++) {
                  var byteArray = byteCharacters.charCodeAt(offset);
                  byteArrays.push(byteArray);
              }
    
              // Create a Blob from the byte array
              var blob = new Blob([new Uint8Array(byteArrays)], { type: 'application/pdf' });
    
              // Create a link to trigger the download
              var link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `${fileName}.pdf`; // Set the file name
              link.click(); // Programmatically click the link to trigger the download
            } else {
              console.error('Failed to generate the PDF:', response.data);
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error('Ajax error:', textStatus, errorThrown);
          },
        });
    });
}